<template>
  <div class="flex flex-col lg:flex-row justify-center relative lg:pb-12">
    <div class="flex-50 relative" v-for="product, index in products" :key="index" :class="index == 0 ? 'bg-secondary':'bg-primary'">
      <div class="flex justify-center items-center py-10 lg:py-20 animate" data-animate-type="animate-fade-in">
        <h2 class="font-bold font-serif text-4xl lg:text-5xl max-w-xs text-center data-hero-category animate ease-in-out duration-1000 will-change-transform" :class="index == 0 ? 'text-primary':'text-secondary'">{{product.title}}</h2>
      </div>
      <div class="flex flex-col-reverse" :class="index == 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'">
        <div class="flex-50 relative z-0 animate pt-10 lg:pt-0 lg:rounded-full overflow-hidden" data-animate-type="animate-fade-in">
          <nuxt-img provider="sirvProvider" :alt="product.title" v-if="product.image.data.attributes.url" width="350" :src="product.image.data.attributes.url" class="aspect-square w-full h-full object-cover data-hero-category ease-in-out duration-700 will-change-auto" data-type="circle-clip" />
        </div>
        <div class="flex-50 justify-center flex flex-col px-10 lg:px-16 py-b lg:pb-7 gap-5 animate" data-animate-type="animate-fade-in" :class="index == 1 ? 'revert-button' : ''">
          <h3 class="font-bold text-2xl lg:text-4xl data-hero-category ease-in-out duration-1000" data-volacity="0.2" :class="index == 0 ? 'text-primary':'text-secondary'">{{product.subtitle}}</h3>
          <p class="data-hero-category ease-in-out duration-1000 will-change-transform" :class="index == 0 ? 'text-primary':'text-secondary'">{{product.text}}</p>
          <div class="data-hero-category ease-in-out duration-1000 will-change-transform" data-volacity="300">
            <PrimaryButton
              v-if="product.link"
              :to="product.link">
                {{ $t('Order') }}
            </PrimaryButton>
          </div>
        </div>
      </div>
      <HeroCategoryFlower />
      <SvgImage
        :animate="true"
        animation="animate-draw-flowers"
        offset="1000" icon="19Flower" width="212" height="529"
        class="absolute z-0 top-0 opacity-20 lg:opacity-75 data-hero-category ease-in-out duration-1000 will-change-transform" data-volacity="300"
        :class="index == 0 ? 'left-0 stroke-[#3e4e39] scale-x-[-1]' : 'right-0 stroke-[#edd3ca]'"
        />
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .subline {
    &::after {
      opacity: 0;
      visibility: hidden;
    }
    &-left {
      clip-path: inset(0 50% 0 0);
    }
    &-right {
      clip-path: inset(0 0 0 50%);
    }
  }
  .revert-button {
    .bg-primary {
      background: var(--c-secondary)!important;
    }
    .span {
      svg {
        path {
          stroke: var(--c-secondary)!important;
        }
      }
    }
  }
</style>
<script>
  import { useContext, onMounted, onUnmounted, defineComponent } from '@nuxtjs/composition-api';
  import PrimaryButton  from '~/components/Headless/PrimaryButton.vue';
  import SvgImage from '~/components/General/SvgImage.vue';
  import useParallax from '~/helpers/headless/useParallax.ts';
  import HeroCategoryFlower from '~/components/General/HeroCategoryFlower.vue';

  export default defineComponent({
    name: 'HeroCategory',
    components: {
      PrimaryButton,
      SvgImage,
      HeroCategoryFlower
    },
    props: {
      products: {
        type: [Object, Array]
      },
      subline: {
        type: String,
        default: 'Designed by our florists in Chichester'
      }
    },
    setup() {
      const { app } = useContext();

      onMounted(() => {
        if (app.$device.isDesktop) {
          useParallax('data-hero-category', 1, true);
        }
      })

      onUnmounted(() => {
        if (app.$device.isDesktop) {
          useParallax('data-hero-category', 1, false);
        }
      })
    }
  })
</script>
